import React from "react";
import "./Skills.css";
import { motion } from "framer-motion";
import { 
  FaHtml5, FaCss3Alt, FaJsSquare, FaBootstrap, 
  FaReact, FaNodeJs, FaGithub, FaDatabase, FaAngular
} from "react-icons/fa";
import { SiMongodb, SiExpress, SiTypescript } from "react-icons/si";
import { portfolioData } from "../../data/portfolioData";

const Skills = () => {
  const { skills } = portfolioData;

  // Icon mapper helper
  const getIcon = (iconClass) => {
    switch (iconClass) {
      case "html5": return <FaHtml5 className="icon-html" />;
      case "css3": return <FaCss3Alt className="icon-css" />;
      case "javascript": return <FaJsSquare className="icon-js" />;
      case "bootstrap": return <FaBootstrap className="icon-bootstrap" />;
      case "react": return <FaReact className="icon-react" />;
      case "angular": return <FaAngular className="icon-angular" />;
      case "node": return <FaNodeJs className="icon-node" />;
      case "express": return <SiExpress className="icon-express" />;
      case "github": return <FaGithub className="icon-github" />;
      case "sql": return <FaDatabase className="icon-sql" />;
      case "mongodb": return <SiMongodb className="icon-mongo" />;
      case "typescript": return <SiTypescript className="icon-ts" />;
      default: return <FaDatabase />;
    }
  };

  return (
    <section className="skills-section" id="skills">
      <div className="skills-container">
        
        <motion.div 
          className="skills-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="skills-subtitle">MY TOOLBOX</span>
          <h2 className="skills-title">Technologies & Skills</h2>
          <p className="skills-description">
            Here are the primary languages, frameworks, and tools I use to bring ideas to life.
          </p>
        </motion.div>

        <div className="skills-grid">
          {skills.map((skill, index) => (
            <motion.div 
              key={index}
              className="skill-card"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              whileHover={{ y: -5 }}
            >
              <div className="skill-icon-box">
                {getIcon(skill.iconClass)}
              </div>
              <span className="skill-name">{skill.name}</span>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Skills;